<template>
    <main>
        <div class="icons-container">
            <div class="icon-item" v-for="icon in icons" :key="icon">
                <i :class="`i-andy-${icon} i-andy-m`"></i>
                <span>{{ icon }}</span>
            </div>
        </div>
        <div class="icons-container-sizes">
            <div class="icon-item">
                <i class="i-andy-analytics i-andy-xs"></i>
                <span>XS</span>
            </div>
            <div class="icon-item">
                <i class="i-andy-analytics i-andy-s"></i>
                <span>S</span>
            </div>
            <div class="icon-item">
                <i class="i-andy-analytics i-andy-m"></i>
                <span>M</span>
            </div>
            <div class="icon-item">
                <i class="i-andy-analytics i-andy-l"></i>
                <span>L</span>
            </div>
            <div class="icon-item">
                <i class="i-andy-analytics i-andy-xl"></i>
                <span>XL</span>
            </div>
            <div class="icon-item">
                <i class="i-andy-analytics i-andy-xs color-1"></i>
                <span>XS</span>
            </div>
            <div class="icon-item">
                <i class="i-andy-analytics i-andy-s color-2"></i>
                <span>S</span>
            </div>
            <div class="icon-item">
                <i class="i-andy-analytics i-andy-m color-3"></i>
                <span>M</span>
            </div>
            <div class="icon-item">
                <i class="i-andy-analytics i-andy-l color-4"></i>
                <span>L</span>
            </div>
            <div class="icon-item">
                <i class="i-andy-analytics i-andy-xl color-5"></i>
                <span>XL</span>
            </div>
        </div>
    </main>
</template>
<script>
export default {
    name: 'IconsGallery',
    data() {
        return {
            icons: [
                "add", "ai", "analytics", "attach", "avatar", "avatar-1", "bell", "bell-disabled",
                "blank-document", "bluetooth", "bullet-list", "cable", "calendar", "camera", "camera-off",
                "chart-bar", "chat", "chatbox", "check", "check-circle", "checked-circle", "chevron-arrow-down",
                "chevron-arrow-up", "chevron-down", "chevron-input-derecha", "chevron-input-down", "chevron-input-right",
                "chevron-input-up", "chevron-left", "chevron-right", "chevron-up", "circle-exclamation", "clock-black",
                "close", "collapse", "condition", "convert", "copy", "corner-right-down", "corner-right-up",
                "countdown", "delete", "done", "donut", "double-check", "down-arrow", "download", "drag",
                "edit", "edit-columns", "editor-bold", "editor-clea", "editor_italic", "editor_underline", "empty_image",
                "error", "error-circle", "error-fill", "excel", "exclamation", "expand", "export", "external",
                "extra-notes", "eye-preview-dark", "file", "file-attach", "file-1", "filter1", "filter2", "folder",
                "format-datetime", "format-link", "format-mail", "format-number", "format-sign", "format-temperature",
                "goBackward", "goForward", "grab-arrows", "group", "heart", "history", "home", "hourglass-end",
                "hourglass-start", "hourglass-warning", "image", "info-main", "input-date", "input-pin", "input-text",
                "input-time", "key", "keyBack", "keyboard", "left-arrow", "less", "Link", "locales", "location",
                "lock", "lock-info", "logout", "menu-audit", "menu-checklist", "menu-chocolate", "menu-collapse-main",
                "menu-config", "menu-dashboard", "menu-help", "menu-label", "menu-library", "menu-logbook",
                "menu-operational_timers", "menu-register", "menu-sensor", "menu-supervise-main", "menu-task",
                "menu-timer", "menu-traceability", "menu-updates", "more", "move", "mute", "next-state",
                "notes-available", "notes-create", "no-wifi", "onboarding", "order", "ordered-list", "pdf", "percent",
                "phone", "phone-1", "pin", "print-pdf", "print-pdf-1", "printer", "printer-1", "refresh", "refresh-2",
                "remote-control-line", "renew", "right-arrow", "receptor", "save", "search-aaaaa", "send", "share",
                "signal-wifi-2", "star", "store", "subitem", "suggestion", "task-note", "task-uncompleted",
                "task-warning", "ticket", "time-active", "training", "translate", "ubication", "uncheck",
                "unchecked-circle", "undo", "unidentified", "unlock", "up-arrow", "upload", "usb", "user",
                "user-check", "video", "video-1", "volume", "wifi", "word", "world", "zip", "zoom-in", "zoom-out"
            ],
        }
    }
}
</script>
<style lang="scss" scoped>
main {
    width: 80vw;
    margin: 100px auto;

    .icons-container {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
        gap: 10px;

        .icon-item {
            @include display-flex();
            @include flex-direction(column);
            @include align-items(center);
            span {
                font-size: 10px;
            }
        }
    }

    .icons-container-sizes {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
        align-items: end;
        gap: 10px;
        margin-top: 20px;

        .icon-item {
            @include display-flex();
            @include flex-direction(column);
            @include align-items(center);
            padding: 4px;
            span {
                font-size: 10px;
            }

            .color-1 {
                color: $color-info-500;
            }
            .color-2 {
                color: $color-success-500;
            }
            .color-3 {
                color: $color-warning-500;
            }
            .color-4 {
                color: $color-error-500;
            }
            .color-5 {
                color: $color-neutral-500;
            }
        }
    }
}
</style>